/**
 * First concrete page the signed-in user is allowed to open.
 * Parents are skipped until a child with its own screen is allowed,
 * so a denied Dashboard does not hide a later permitted module.
 */
export const findFirstAllowedPath = (routes = [], isReadAllowed = () => false) => {
  for (const route of routes || []) {
    if (Array.isArray(route?.children) && route.children.length) {
      const childPath = findFirstAllowedPath(route.children, isReadAllowed)
      if (childPath) return childPath
    }
    const path = route?.path
    const hasScreen = Boolean(path && route?.component && !String(path).includes(":"))
    if (!hasScreen) continue
    if (isReadAllowed(route)) return path
  }
  return ""
}

export const toAppPath = (
  path,
  { roleType = "", sourceRole = "", tenantId = "" } = {}
) => {
  if (!path) return ""
  const full = `/${roleType}${path}`
  if (path !== "/dashboard") return full
  const isSaaS = String(sourceRole || "").toLowerCase().includes("saas")
  if (isSaaS) return `${full}?page=home`
  return `${full}?page=autonomous&retailer=${tenantId || ""}&subpage=0`
}
